<template>
    <div>

        <Dialog :visible.sync="exibirModalNovo" header="Ajuste Parcial" :modal="true" :style="{ width: '600px' }"
            @hide="fecharModal">
            <div class="p-fluid p-formgrid p-grid" v-if="eventosAjusteParcial.length > 0">
                <div class="p-field p-col-12 p-md-12">
                    <label>Evento abonado</label>
                    <Dropdown v-model="idEventoAjustadoSelecionado" :options="eventosAjusteParcial"
                        optionLabel="descricaoEventoReal" optionValue="id" placeholder="Selecione para editar"
                        appendTo="body" dataKey="id" @change="selecionarEventoEditar" />
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label for="justificativa">Justificativa</label>
                    <Dropdown id="justificativa" v-model="idJustificativaSelecionada" :options="justificativas"
                        required="true" optionLabel="descricao" optionValue="id" placeholder="Selecione" appendTo="body"
                        dataKey="id" />
                    <small class="p-invalid" v-if="enviandoForm && !idJustificativaSelecionada">Selecione uma
                        justificativa</small>
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12" v-if="!bloqSelecionarEvento">
                    <label for="evento">Evento</label>
                    <Dropdown id="evento" v-model="idEventoInjustificadoSelecionado" :options="eventosInjustificados"
                        required="true" optionLabel="descricaoEventoReal" optionValue="id" placeholder="Selecione"
                        appendTo="body" dataKey="id" />
                    <small class="p-invalid" v-if="enviandoForm && !idEventoInjustificadoSelecionado">Selecione um
                        evento</small>
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label>Data início</label>
                    <Calendar v-model="ajusteParcial.diaInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"
                        appendTo="body" :locale="localeCalendarBR" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Data final</label>
                    <Calendar v-model="ajusteParcial.diaFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"
                        appendTo="body" :locale="localeCalendarBR" />
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="horaInicio">Hora início</label>
                    <InputText id="horaInicio" v-model="ajusteParcial.horaInicio" maxlength="5" placeholder=":"
                        class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('horaInicio')"
                        required="true" autocomplete="off" />
                    <small class="p-invalid" v-if="enviandoForm && !ajusteParcial.horaInicio">Informe a hora início</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="horaFinal">Hora final</label>
                    <InputText id="horaFinal" v-model="ajusteParcial.horaFinal" maxlength="5" placeholder=":"
                        class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('horaFinal')"
                        required="true" autocomplete="off" />
                    <small class="p-invalid" v-if="enviandoForm && !ajusteParcial.horaFinal">Informe a hora final</small>
                </div>
            </div>
            <template #footer>
                <div class="p-d-flex p-jc-between">
                    <h6 class="p-text-bold">Marcações do dia {{ dataPonto }}</h6>
                    <div>
                        <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal" />
                        <Button label="Salvar" icon="pi pi-check" @click="executarAcao('SALVAR')" />
                        <Button label="Excluir" class="p-button-danger" icon="pi pi-times" @click="executarAcao('EXCLUIR')"
                            v-if="ajusteParcial.id != null" />
                    </div>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import ControlePontoService from '@/service/ControlePontoService';
import AjusteParcial from '@/model/AjusteParcial';
import { exibirMensagem, formatarEtradaHora, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            bloqSelecionarEvento: false,
            enviandoForm: false,
            dataPonto: null,
            exibirModalNovo: false,
            ajusteParcial: new AjusteParcial(),
            idJustificativaSelecionada: null,
            justificativas: [],
            idEventoInjustificadoSelecionado: null,
            eventosInjustificados: [],
            idEventoAjustadoSelecionado: null,
            eventosAjusteParcial: [],
            requisicao: {},
            localeCalendarBR: localeCalendarBR,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        processar(req) {
            this.requisicao = { ...req };
            this.dataPonto = this.formatarStringData(req.dataPonto);
            this.ajusteParcial.diaInicio = this.formatarStringData(req.dataPonto);
            this.ajusteParcial.diaFinal = this.formatarStringData(req.dataPonto);
            this.controlePontoService.listarEventosAbonos(req)
                .then(resp => {
                    this.eventosInjustificados = resp.data.eventosInjustificados;
                    if (resp.data.eventosAjusteParcial.length > 0) {
                        let evento = {
                            descricaoEventoReal: 'Selecione para editar',
                            id: null
                        }
                        this.eventosAjusteParcial.push(evento);
                        Array.prototype.push.apply(this.eventosAjusteParcial, resp.data.eventosAjusteParcial);
                        this.eventosAjusteParcial.forEach(ev => {
                            if (ev.id) {
                                ev.ajusteParcial.dataInicio = this.formatarStringData(ev.ajusteParcial.dataInicio);
                                ev.ajusteParcial.dataFinal = this.formatarStringData(ev.ajusteParcial.dataFinal);
                            }
                        });
                    }
                    this.justificativas = resp.data.justificativas;
                    this.exibirModalNovo = true;
                })
                .catch(erro => { console.log(erro); exibirMensagem(this, erro) });
        },
        executarAcao(acao) {
            if (acao == 'SALVAR') {
                if (this.ajusteParcial.id == null) {
                    this.salvar();
                } else {
                    this.alterar();
                }
            } else {
                this.excluir();
            }
        },
        salvar() {
            this.enviandoForm = true;
            if (this.idJustificativaSelecionada != null && this.idEventoInjustificadoSelecionado != null) {
                if (!this.ajusteParcial.horaInicio || !this.ajusteParcial.horaFinal) {
                    return;
                }
                let justificativa = null;
                this.justificativas.forEach(just => {
                    if (just.id == this.idJustificativaSelecionada) {
                        justificativa = { ...just };
                    }
                });
                let eventoAjustar = null;
                this.eventosInjustificados.forEach(evento => {
                    if (evento.id == this.idEventoInjustificadoSelecionado) {
                        eventoAjustar = { ...evento };
                    }
                });
                let ajuste = { ...this.ajusteParcial };
                ajuste.diaInicio = this.formatarData(ajuste.diaInicio);
                ajuste.diaFinal = this.formatarData(ajuste.diaFinal);
                ajuste.codigoEvento = eventoAjustar.codigo;
                this.requisicao['idEventoAjustar'] = this.idEventoInjustificadoSelecionado;
                this.requisicao['justificativa'] = justificativa;
                this.requisicao['ajusteParcial'] = ajuste;
                this.controlePontoService.salvarAjusteParcial(this.requisicao)
                    .then(resp => {
                        exibirMensagem(this, resp);
                        this.callback(ajuste.diaInicio, ajuste.diaFinal);
                        this.fecharModal();
                    })
                    .catch(erro => {
                        exibirMensagem(this, erro)
                    });
            }
        },
        alterar() {
            this.enviandoForm = true;
            if (this.idJustificativaSelecionada != null) {
                if (!this.ajusteParcial.horaInicio || !this.ajusteParcial.horaFinal) {
                    return;
                }
                let justificativa = null;
                this.justificativas.forEach(just => {
                    if (just.id == this.idJustificativaSelecionada) {
                        justificativa = { ...just };
                    }
                });
                let ajuste = { ...this.ajusteParcial };
                ajuste.diaInicio = this.formatarData(ajuste.diaInicio);
                ajuste.diaFinal = this.formatarData(ajuste.diaFinal);
                this.requisicao['idEventoAbonado'] = this.idEventoAjustadoSelecionado;
                this.requisicao['justificativa'] = justificativa;
                this.requisicao['ajusteParcial'] = ajuste;
                this.controlePontoService.alterarAjusteParcial(this.requisicao)
                    .then(resp => {
                        exibirMensagem(this, resp);
                        this.callback(ajuste.diaInicio, ajuste.diaFinal);
                        this.fecharModal();
                    })
                    .catch(erro => {
                        exibirMensagem(this, erro)
                    });
            }
        },
        excluir() {
            this.requisicao['idEventoAjustado'] = this.idEventoAjustadoSelecionado;
            this.controlePontoService.excluirAjusteParcial(this.requisicao)
                .then(resp => {
                    exibirMensagem(this, resp);
                    this.callback(this.formatarData(this.ajusteParcial.diaInicio), this.formatarData(this.ajusteParcial.diaFinal));
                    this.fecharModal();
                })
                .catch(erro => {
                    exibirMensagem(this, erro)
                });
        },
        selecionarEventoEditar() {
            if (this.idEventoAjustadoSelecionado != null) {
                this.bloqSelecionarEvento = true;
                let eventoAjustado = null;
                this.eventosAjusteParcial.forEach(evento => {
                    if (evento.id == this.idEventoAjustadoSelecionado) {
                        eventoAjustado = evento;
                    }
                });
                let ajuste = { ...eventoAjustado.ajusteParcial };
                ajuste.diaInicio = this.formatarStringData(ajuste.diaInicio);
                ajuste.diaFinal = this.formatarStringData(ajuste.diaFinal);
                this.ajusteParcial = ajuste;
                this.idJustificativaSelecionada = eventoAjustado.justificativa.id;
            } else {
                this.bloqSelecionarEvento = false;
                this.ajusteParcial = new AjusteParcial();
                this.idJustificativaSelecionada = null;
            }
        },
        formatarData(data) {
            if (!data) {
                return null;
            }
            let strData = null;
            if (data instanceof Date) {
                let dt = data;
                let mes = dt.getMonth();
                let dia = dt.getDate();
                strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0' + (mes + 1) : '' + (mes + 1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
            } else {
                let partes = data.split('/');
                strData = partes[2] + '-' + partes[1] + '-' + partes[0];
            }
            return strData;
        },
        formatarStringData(data) {
            if (!data || data instanceof Date) {
                return '';
            }
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },
        limparEntradaHoraInvalida(campo) {
            if (this.ajusteParcial[campo] == null) {
                return;
            }
            let regex = /[0-2][0-9]:[0-5][0-9]/g;
            if (!this.ajusteParcial[campo].match(regex)) {
                this.ajusteParcial[campo] = '';
            }
        },
        validarEntraHora(event) {
            formatarEtradaHora(event);
        },
        fecharModal() {
            this.bloqSelecionarEvento = false;
            this.enviandoForm = false;
            this.idJustificativaSelecionada = null;
            this.idEventoInjustificadoSelecionado = null;
            this.idEventoAjustadoSelecionado = null;
            this.eventosInjustificados = [];
            this.eventosAjusteParcial = [];
            this.requisicao = {};
            this.exibirModalNovo = false;
            this.ajusteParcial = new AjusteParcial();
        }
    },
    created() {
        this.controlePontoService = new ControlePontoService();
    },
}
</script>

<style></style>